// extracted by mini-css-extract-plugin
module.exports = {"blogItem":"index-module--blogItem--3i7Df","blogItemImage":"index-module--blogItemImage--1LULN","blogItemDescription":"index-module--blogItemDescription--3zQ1d"};